import axios from 'axios';
import { showErrorToast } from '../components/toasts';

const isDev = false;

export const BACKEND = isDev ? "http://localhost:5007/" : "https://ngloans.com.au/";
export const API_URL = `${BACKEND}api/v1`;

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

$api.interceptors.request.use((config: any) => {
  config.headers.Authorization = `bearer ${localStorage.getItem('token')}`;
  return config;
});

$api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  console.log(error)
  const expectedError =
    error.message &&
    error.response.status >= 4000 &&
    error.response.status < 500;
  if (!expectedError) {
    console.log("An unexpected Error Occourred!");
  }
  if (error.response.status === 401 || error.response.status === 403) {
    localStorage.removeItem("token");
    alert("Session Expired! Please Login Again")
    window.location.pathname = "/"
    console.log(error)
  }
  return Promise.reject(error);
}
);

export const $public = (url: string) => {
  if (!url) return ""
  if (url[0] === '/' && BACKEND[BACKEND.length - 1] === '/') {
    url = url.substring(1);
    return `${BACKEND}${url}`;
  } else if (url[0] !== '/' && BACKEND[BACKEND.length - 1] !== '/') {
    return `${BACKEND}/${url}`;
  } else {
    return `${BACKEND}${url}`;
  }
};

export default $api;
